import {showAlert} from './functions';

class Form
{
    constructor($form) {
        this.$form = $form;
        this.storedFiles = [];
        this.rules = {};
        this.messages = {};
        this.action = null;
        this.invalidHandler = null;
        this.$attachments = $form.find('.attachments');
        this.$fileErrors = $form.find('.file-errors');
        this.$fileInputPlaceholder = $form.find('.file-input-replacer');
        this.$fileInput = $form.find('.file-input');
        this.validExts = [];
    }

    setValidationRules(rules) {
        this.rules = rules;

        return this;
    }

    setValidExts(validExts) {
        this.validExts = validExts;

        return this;
    }

    addValidationRule(key, rules) {
        this.rules[key] = rules;

        return this;
    }

    addFileValidationRule(key) {
        this.rules[key] = {
            required: () => {
                return this.storedFiles.length <= 0;
            }
        };

        return this;
    }

    setMessages(messages) {
        this.messages = messages;

        return this;
    }

    addMessages(key, messages) {
        this.messages[key] = messages;

        return this;
    }

    setAction(name) {
        this.action = name;

        return this;
    }

    setInvalidHandler(func) {
        if (typeof func === 'function') {
            this.invalidHandler = func;
        }

        return this;
    }

    enable() {
        this.$form.validate({
            ignore: [],
            rules: this.rules,
            messages: this.messages,
            focusInvalid: false,
            errorElement: 'div',
            errorClass: 'error',
            invalidHandler: this.invalidHandler,
            submitHandler: (form, e) => {
                var formData = new FormData(form),
                    submit = $(form).find('button[type="submit"]'),
                    alertbox = $(form).find('.alertbox span'),
                    Percentage = 0,
                    progressBar = $('#progressbar'),
                    validExts = this.validExts,
                    file_max_size = 15242880;

                e.preventDefault();

                if (this.action === null) {
                    return false;
                }

                if (this.storedFiles.length > 15) {
                    alertbox.text('only up to 15 files are allowed.');
                    alertbox.parent().fadeIn(300);

                    return false;
                }

                if (this.storedFiles.length > 0) {
                    var len = this.storedFiles.length,
                        i;

                    for (i = 0; i < len; i++) {
                        var file_ext = this.storedFiles[i].name.split('.').pop().toLowerCase();

                        if ($.inArray(file_ext, validExts) === -1 || this.storedFiles[i].size > file_max_size) {
                            alertbox.text('form has errors.');
                            alertbox.parent().fadeIn(300);

                            return false;
                        }

                        formData.append('filess[]', this.storedFiles[i]);
                    }
                }

                alertbox
                    .text('')
                    .parent()
                    .hide();

                formData.append('action', this.action);
                formData.append('security', FR.ajax_nonce);

                $.ajax({
                    url: FR.ajax_url,
                    data: formData,
                    type: 'POST',
                    cache: false,
                    processData: false,
                    contentType: false,
                    async: true,
                    headers: {
                        'cache-control': 'no-cache'
                    },
                    xhr: function() {
                        var myXhr = $.ajaxSettings.xhr();

                        if (myXhr.upload) {
                            myXhr.upload.addEventListener('progress', function(e) {
                                if (e.lengthComputable) {
                                    var max = e.total,
                                        current = e.loaded,
                                        Percentage = Math.round((current * 100) / max, 0);

                                    progressBar.css('display', 'block')
                                        .fadeIn()
                                        .children('.progress__inner')
                                        .width(Percentage + '%');
                                }
                            }, false);
                        }
                        return myXhr;
                    },
                    beforeSend: function() {
                        submit.prop('disabled', true);
                    },
                    success: function(data) {
                        submit.prop('disabled', false);
                        Percentage = 0;

                        if (data.passed === true) {
                            form.reset();
                            $('.attachments').empty();

                            showAlert('Message sent successfully');

                        } else if (data.passed === false && data.errmsg !== '') {
                            submit.prop('disabled', false);
                            progressBar.css('display', 'none').children('.progress__inner').width('0%');
                            Percentage = 0;

                            alertbox.text(data.errmsg);
                            alertbox.parent().fadeIn(300);
                        }
                    },
                    error: function(error) {
                        progressBar.css('display', 'none').children('.progress__inner').width('0%');
                        Percentage = 0;
                        submit.prop('disabled', false);

                        if (error.responseText !== '') {
                            alertbox.text('spróbuj ponownie później.');
                            alertbox.parent().fadeIn(300);
                        }

                    }
                });

                return false;
            }
        });
        this._initEvents();
    }

    _initEvents() {
        this.$fileInput.on('change', e => this._handleFileSelect(e.target.files));
        this._initRemoveFileEvent();
        this._initDropFileEvent();
    }

    _initRemoveFileEvent() {
        this.$attachments.find('.remove-file').one('click', e => this._removeFile(e));
    }

    _initDropFileEvent() {
        this.$fileInputPlaceholder
            .on('drag dragstart dragend dragover dragenter dragleave drop', e => {
                e.preventDefault();
                e.stopPropagation();
            })
            .on('dragover dragenter', () => {
                this.$fileInputPlaceholder.addClass('is-dragover');
            })
            .on('dragleave dragend drop', () => {
                this.$fileInputPlaceholder.removeClass('is-dragover');
            })
            .on('drop', e => {
                this._handleFileSelect(e.originalEvent.dataTransfer.files);
            });
    }

    _removeFile(e) {
        var $that = $(e.currentTarget),
            file = $that.data('file'),
            i;

        for (i = 0; i < this.storedFiles.length; i++) {
            if (this.storedFiles[i].name === file) {
                this.storedFiles.splice(i, 1);
                break;
            }
        }

        $that.parent().remove();

        if ($.isEmptyObject(this.storedFiles)) {
            this.$fileInput.val('');
        }
    }

    _getAttachmentHtml(fileName, error) {
        var html = '<li' + ((error !== undefined) ? ' style="color:red"' : '') + '><div>'
            + fileName
            + '</div><div class="remove-file" data-file="'
            + fileName
            + '"><span>&times;</span></div>';

        if (error !== undefined) {
            html += '<div class="filerr">(' + error + ')</div>';
        }

        html += '</li>';

        return html;
    }

    _handleFileSelect(files) {
        var filesArr = Array.prototype.slice.call(files),
            file_max_size = 15242880;

        this.$fileErrors.empty();

        filesArr.forEach((f, i) => {
            var reader = new FileReader(),
                file_ext = f.name.split('.').pop().toLowerCase();

            if ($.inArray(file_ext, this.validExts) === -1) {
                reader.onload = e => {
                    this.$attachments.append(this._getAttachmentHtml(f.name, 'Not allowed file type.'));
                    this._initRemoveFileEvent();
                };
            } else if (f.size > file_max_size) {
                reader.onload = e => {
                    this.$attachments.append(this._getAttachmentHtml(f.name, 'File is too big.'));
                    this._initRemoveFileEvent();
                };
            } else {
                var name = f.name.split('.')
                    .shift()
                    .replace(/[^0-9a-zA-Z\-_()\[\] ąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+/g, '_'),
                    newFileName = name + '.' + file_ext,
                    duplicate = false;

                this.$attachments.find('.remove-file').each((i, attachament) => {
                    if (newFileName === $(attachament).data('file')) {
                        this.$attachments.append(this._getAttachmentHtml(f.name, 'Plik o tej samej nazwie już istnieje'));
                        this._initRemoveFileEvent();
                        duplicate = true;
                    }
                });

                if(!duplicate) {
                    f = new File([f], newFileName);

                    reader.onload = e => {
                        this.$attachments.append(this._getAttachmentHtml(f.name));
                        this._initRemoveFileEvent();
                    };
                }
            }

            this.storedFiles.push(f);
            reader.readAsDataURL(f);
        });
    }
}

$(() => {
    $.validator.addMethod('lettersonly', function(value, element) {
        return this.optional(element) || /^[a-zA-Z\- ąćęłńóśżźĄĆĘŁŃÓŚŻŹ]+$/i.test(value);
    }, 'Letters and (-) are only allowed signs');

    $.validator.addMethod('phone', function(value, element) {
        return this.optional(element) || /^[0-9\-+() ]+$/i.test(value);
    }, 'This field contain not allowed sings.');

    $.validator.addMethod('fullname', function(value, element) {
        return value.split(' ').length === 2;
    }, 'Provide your name and surname.');

    $('#newsletter-form').validate({
        ignore: [],
        rules: {
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            email: {
                maxlength: 'Email is invalid.'
            }
        },
        focusInvalid: false,
        errorElement: 'div',
        errorClass: 'error',
        submitHandler: function(form) {
            var $form = $(form),
                formData = new FormData(form),
                $submit = $form.find('button[type="submit"]'),
                $alertbox = $form.find('.alertbox span'),
                Percentage = 0,
                progressBar = $('#progressbar');

            formData.append('action', 'process_newsletter_form');
            formData.append('security', FR.ajax_nonce);

            $alertbox.text('');
            $alertbox.parent().hide();

            $.ajax({
                url: FR.ajax_url,
                data: formData,
                type: 'POST',
                cache: false,
                processData: false,
                contentType: false,
                async: true,
                headers: {
                    'cache-control': 'no-cache'
                },
                xhr: function() {
                    var myXhr = $.ajaxSettings.xhr();

                    if (myXhr.upload) {
                        myXhr.upload.addEventListener('progress', function(e) {
                            if (e.lengthComputable) {
                                var max = e.total,
                                    current = e.loaded,
                                    Percentage = Math.round((current * 100) / max, 0);

                                progressBar.css('display', 'block')
                                    .fadeIn()
                                    .children('.progress__inner')
                                    .width(Percentage + '%');
                            }
                        }, false);
                    }

                    return myXhr;
                },
                beforeSend: function() {
                    $submit.prop('disabled', true);
                },
                success: function(data) {
                    $submit.prop('disabled', false);
                    progressBar.css('display', 'none').children('.progress__inner').width('0%');
                    Percentage = 0;

                    if (data.passed === true) {
                        form.reset();
                        $('#newsletter-wrapper').fadeOut(300, function() {
                            $('#newsletter-typ').fadeIn(300).css('display', 'flex');
                        });
                    } else if (data.passed === false && data.errmsg !== '') {
                        $alertbox.text(data.errmsg);
                        $alertbox.parent().fadeIn(300);
                    }

                },
                error: function(error) {
                    $submit.prop('disabled', false);
                    progressBar.css('display', 'none').children('.progress__inner').width('0%');
                    Percentage = 0;

                    if (error.responseText !== '') {
                        $alertbox.text('try again alter.');
                        $alertbox.parent().fadeIn(300);
                    }
                }
            });

            return false;
        }
    });

    const applyForm = new Form($('.apply-form-container'));

    applyForm
        .setAction('process_apply_form')
        .setValidExts(['pdf'])
        .setValidationRules({
            offerName: {
                required: true
            },
            name: {
                required: true,
                lettersonly: true,
                maxlength: 50,
                fullname: true
            },
            email: {
                required: true,
                email: true
            },
            msg: {
                maxlength: 2000,
                required: true,
            },
            phone: {
                phone: true,
                maxlength: 20,
                minlength: 9
            },
            check: {
                required: true
            },
            check1: {
                required: true
            },
            check2: {
                required: true
            }
        })
        .setMessages({
            name: {
                required: ' Tell us your name and surname - it will make our communication easier',
                maxlength: 'Allowed word length is 50.'
            },
            email: {
                required: 'We need your e-mail address to respond to your message',
                maxlength: 'Email is invalid.'
            },
            msg: {
                required: 'Write something about yourself. This will help us match your skills to the team.'
            }
        })
        .setInvalidHandler(function(e, validator) {
            var list = validator.errorList;

            if (Array.isArray(list)) {
                var $element = $(list[0].element),
                    $scrollable = $element.parents('.apply-section'),
                    scrollableTop = $scrollable.offset().top,
                    scrollableSt = $scrollable.scrollTop(),
                    top,
                    st;

                if ($element.attr('type') === 'checkbox') {
                    $element = $element.parents('.checkbox-input');
                }

                top = $element.offset().top;
                st = top - scrollableTop + scrollableSt - 50;

                $scrollable.animate({
                    scrollTop: st
                }, 500);
            }
        })
        .enable();

    const contactForm = new Form($('.form-container.contact-form'));

    contactForm
        .setAction('process_contact_form')
        .setValidExts([
            'jpg',
            'png',
            'jpeg',
            'csv',
            'pdf',
            'odt',
            'docx',
            'doc',
            'txt',
            'mp4',
            'avi',
            'srt',
            'vtt',
            'zip',
            'mp3',
            'gif',
            'xls',
            'xlsx',
            'ods'
        ])
        .setValidationRules({
            name: {
                required: true,
                lettersonly: true,
                maxlength: 50,
                fullname: true
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
                phone: true,
                maxlength: 20,
                minlength: 9
            },
            msg: {
                required: true,
                maxlength: 2000
            },
            budget: {
                range: [1, 3]
            },
            check1: {
                required: true
            }
        })
        .setMessages({
            name: {
                required: ' Tell us your name and surname - it will make our communication easier',
                maxlength: 'Allowed word length is 50.'
            },
            email: {
                required: 'We need your e-mail address to respond to your message',
                maxlength: 'Email is invalid.'
            },
            phone: {
                required: 'It will be easier for us to contact you if you give us your phone number'
            },
            msg: {
                required: 'How can we help you? The more you tell us, the better we’ll be able to respond to your message'
            },
            check1: {
                required: 'This consent will make it possible for us to become familiar with your message'
            }
        })
        .enable();

    const careerForm = new Form($('.form-container.career-form'));

    careerForm
        .setAction('process_apply_form')
        .setValidExts(['pdf'])
        .setValidationRules({
            name: {
                required: true,
                lettersonly: true,
                maxlength: 50,
                fullname: true
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                phone: true,
                maxlength: 20,
                minlength: 9
            },
            check1: {
                required: true
            },
            check2: {
                required: false
            },
            msg: {
                required: true,
                maxlength: 2000
            }
        })
        .setMessages({
            name: {
                required: ' Tell us your name and surname - it will make our communication easier',
                maxlength: 'Allowed word length is 50.'
            },
            email: {
                required: 'We need your e-mail address to respond to your message',
                maxlength: 'Email is invalid.'
            },
            msg: {
                required: 'Write something about yourself. This will help us match your skills to the team.'
            },
            check1: {
                required: 'This consent will make it possible for us to become familiar with your message'
            }
        })
        .enable();
});
